import React from "react";
import { useDispatch } from "react-redux";
import { Trans } from "@lingui/react/macro";
import useAuthHooks from "@Src/components/Auth/useAuthHooks";
import { Creators } from "@ReduxStore/actionTypes";

import "./SsoAuthNeeded.scss";

function SsoAuthNeeded() {
  const dispatch = useDispatch();
  const { SignInButton } = useAuthHooks();

  const closeModal = () => {
    // slight timeout to allow url to change before closing modal
    // SignInButton handles the actual SSO redirect
    setTimeout(() => {
      dispatch(Creators.setAuthOpen(false));
    }, 200);
  };
  return (
    <div className="SsoAuthNeeded-content">
      <div className="SsoAuthNeeded-copy t-body-large">
        <Trans>Please sign in to view this information.</Trans>
      </div>
      <div onClick={() => closeModal()}>
        <SignInButton />
      </div>
    </div>
  );
}

export default SsoAuthNeeded;
